import MarkerIcon from "assets/icons/Marker";
import IconLabel from "./IconLabel";

const LocationLabel = (props) => (
  <IconLabel icon={<MarkerIcon />} fallback="Not entered" {...props} />
);

export default LocationLabel;
